module.exports = __webpack_public_path__ + "media/images/icons/outlined/robot-2fb9fb3a808d902c405fff8cafb843cc.svg";